export const RP_COMPLETE_ADDRESS = 'completeAddress';
export const RP_DATE = 'timeFilter';
export const RP_EC_ID = 'energyCommunityFilter';
export const RP_CONFIGURATION = 'configurationFilter';
export const RP_POD = 'podFilter';
export const RP_PARTECIPANT_NAME = 'membersField';
export const RP_TIME_PERIOD = 'timePeriodField';
export const RP_ADDRESS = 'addressField';
export const RP_ENERGY_CONSUMPTION = 'energyConsumptionField';
export const RP_ENERGY_DISPATCHED = 'dispatchedEnergyField';
export const RP_ENERGY_SHARED = 'sharedEnergyField';
export const RP_TOTAL_REVENUE = 'totalRewardField';
export const RP_SHARED_RATIO = 'sharedRatioField';
export const RP_POD_NAME = 'podField';
export const RP_CONTEMPOREANITY = 'contemporaneityField';

export default {
  RP_COMPLETE_ADDRESS,
  RP_CONFIGURATION,
  RP_DATE,
  RP_EC_ID,
  RP_PARTECIPANT_NAME,
  RP_TIME_PERIOD,
  RP_ADDRESS,
  RP_ENERGY_CONSUMPTION,
  RP_ENERGY_DISPATCHED,
  RP_ENERGY_SHARED,
  RP_TOTAL_REVENUE,
  RP_SHARED_RATIO,
  RP_POD,
  RP_POD_NAME,
  RP_CONTEMPOREANITY,
};
